<template>
    <table class="catalog-settings-input">
        <tr>
            <th></th>
            <td class="pl-4"><label class="label">Jahre:</label></td>
            <td class="pl-4"><label class="label">Seitenzahl:</label></td>
        </tr>
        <tr v-for="option in localeOptions" :key="option.code">
            <th>
                <label class="label">
                    <gb-flag
                        :code="option.flagCode || option.code"
                        size="small"
                        iconPath="/assets/img/flags/"
                    />
                    {{ option.name }}:
                </label>
            </th>
            <td class="pl-4">
                <div class="control">
                    <multiselect
                        :value="getYears(option)"
                        :options="getYearOptions(option)"
                        :multiple="true"
                        @input="value => setYears(option, value)"
                        placeholder="Katalogjahre"
                    />
                </div>
            </td>
            <td class="pl-4">
                <div class="control">
                    <input
                        class="input"
                        type="text"
                        :value="getPage(option)"
                        @input="event => setPage(option, event.target.value)"
                    >
                </div>
            </td>
        </tr>
    </table>
</template>

<script>

import Multiselect from './Multiselect';
import {getTranslationOptions} from "@utilities/functions";
import {years} from '@utilities/variables';

// Katalogjahre + Seitenzahl je Sprache/Katalog eines Gesamtkonzepts. Reine Eingabe:
// Werte kommen als Props, jede Änderung geht als change-Event (key, value) nach oben –
// so nutzen Homepage-Tab (speichert sofort) und Stammdaten-Formular dieselbe Eingabe.
export default {
    props: {
        years: {
            type: Array,
            default: () => [],
        },
        catalogPage: {
            type: String,
            default: '',
        },
        catalogSettings: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        localeOptions: function () {
            const options = getTranslationOptions() || [];
            // Default-Sprache zuerst
            return [...options].sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0));
        },
    },

    methods: {
        // Default-Sprache nutzt die bestehenden Konzept-Felder (years/catalogPage —
        // Liste und XML-Export hängen daran); weitere Kataloge
        // liegen als eigene catalogSettings-Einträge je Locale.
        getSettings: function (option) {
            return (this.catalogSettings || []).find(settings => settings.locale === option.code);
        },

        getYears: function (option) {
            if (option.isDefault) {
                return this.years || [];
            }
            const settings = this.getSettings(option);
            return settings && settings.years ? settings.years : [];
        },

        // Zweistellige Jahre wie überall sonst (Liste, Filter, Export); bereits
        // gespeicherte abweichende Werte bleiben sichtbar und abwählbar.
        getYearOptions: function (option) {
            return [...years, ...this.getYears(option).filter(year => !years.includes(year))];
        },

        getPage: function (option) {
            if (option.isDefault) {
                return this.catalogPage || '';
            }
            const settings = this.getSettings(option);
            return settings ? settings.catalogPage : '';
        },

        setYears: function (option, value) {
            if (option.isDefault) {
                this.$emit('change', 'years', value);
                return;
            }
            this.changeSettings(option, {years: value});
        },

        setPage: function (option, value) {
            if (option.isDefault) {
                this.$emit('change', 'catalogPage', value);
                return;
            }
            this.changeSettings(option, {catalogPage: value});
        },

        changeSettings: function (option, changes) {
            const existing = this.catalogSettings || [];
            let updated;
            if (this.getSettings(option)) {
                updated = existing.map(settings => settings.locale === option.code
                    ? {...settings, ...changes}
                    : settings
                );
            } else {
                updated = [...existing, {
                    locale: option.code,
                    years: [],
                    catalogPage: null,
                    ...changes,
                }];
            }
            this.$emit('change', 'catalogSettings', updated);
        },
    },

    components: {
        Multiselect,
    },
}
</script>
